module.exports = "//static.hsappstatic.net/LoginUI/static-1.15632/img/connect.com-full-logo-color.svg"